export default __webpack_public_path__ + "static/media/FORMAZIONE_ICONA.6a8ee618.svg";